import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';


Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      path: '/o-app',
      name: 'app',
      component: () => import(/* webpackChunkName: "appsy" */ './views/App.vue'),
    },
    {
      path: '/planos',
      name: 'plans',
      component: () => import(/* webpackChunkName: "plans" */ './views/Plans.vue'),
    },
    {
      path: '/registre-se',
      name: 'register',
      component: () => import(/* webpackChunkName: "register" */ './views/Register.vue'),
    },
    {
      path: '/screenshots',
      name: 'screenshots',
      component: () => import(/* webpackChunkName: "screenshots" */ './views/Screenshots.vue'),
    }
  ],
});
